module.exports = __webpack_public_path__ + "static/img/KT-FL.7e9752c.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/KT-FL.png
// module id = vo20
// module chunks = 1